import React from 'react';
import { UICard } from 'ui/card';
import { UISkeleton } from 'ui/skeleton';
import styles from './ui-product-card.module.scss';
import type { UIProductCardVariant } from './UIProductCard';

export interface UIProductCardSkeletonProps {
    variant?: UIProductCardVariant;
    className?: string;
}

/** Placeholder for UIProductCard. Mirrors the real card's structure so swapping
 *  in loaded data doesn't shift layout. */
export function UIProductCardSkeleton({
    variant = 'vertical',
    className = '',
}: UIProductCardSkeletonProps) {
    const isHorizontal = variant === 'horizontal';

    const classes = [
        styles.card,
        styles[`variant-${variant}`],
        styles.skeletonCard,
        className,
    ].filter(Boolean).join(' ');

    return (
        <UICard className={classes}>
            <div className={styles.imageArea}>
                <UISkeleton fill radius="sm" />
            </div>

            <div className={styles.body}>
                <div className={styles.topRow}>
                    <UISkeleton width={56} height={10} />
                    <UISkeleton width={64} height={10} />
                </div>

                <UISkeleton width="100%" height={14} />
                <UISkeleton width="70%" height={14} />

                <div className={styles.metaRow}>
                    <UISkeleton width={96} height={10} />
                    <UISkeleton width={72} height={10} />
                </div>

                {!isHorizontal && <UISkeleton width={104} height={22} radius="md" />}
            </div>

            {isHorizontal && (
                <div className={styles.buyColumn}>
                    <UISkeleton width={104} height={22} radius="md" />
                    <UISkeleton width="100%" height={40} radius="md" />
                </div>
            )}
        </UICard>
    );
}

export default UIProductCardSkeleton;
